// extracted by mini-css-extract-plugin
module.exports = {"container":"Tab2_container__1Jdum","wrapper":"Tab2_wrapper__3EgVP","textWrapper":"Tab2_textWrapper__3T7SI","graphWrapper":"Tab2_graphWrapper__2HFZ1","graph":"Tab2_graph__1hD63"};